jQuery(document).ready(function($){
    $('header.header .menu-trigger').on('click', function() {
       $(this).toggleClass('active');
       $('.mobile-menu-container').slideToggle();
       $('body').toggleClass('overflow-hidden');
    });
    $(window).scroll(function() {
        if ($(window).scrollTop() + $(window).height() >= $(document).height() - 10) {
            $('.floating-contact-container').addClass('bottom-reached');
        } else {
            $('.floating-contact-container').removeClass('bottom-reached');
        }
    });
    $('.menu-item-has-children').hover(function(){
        $('.sub-menu').removeClass('menu-appear');
        $(this).children('.sub-menu').addClass('menu-appear');
        $('.menu-item-has-children').removeClass('active-submenu');
        $(this).addClass('active-submenu');
    });
    $('header').mouseleave(function(){
       $('.sub-menu').removeClass('menu-appear');
       $('.menu-item-has-children').removeClass('active-submenu');
    });
    $('.mobile-menu #topnav').on('scroll', function(){
       $('.mobile-menu .menu-main-navigation-container').addClass('user-scrolled');
    });
});